import React from "react";
import { Box, Typography, Card, CardContent } from "@mui/material";
import { styled } from "@mui/material/styles";
import stay_updated from "../../assets/WhatsNewSection/Stay_Updated_Image.png";
import whats_new_banner from "../../assets/WhatsNewSection/Whats_New_Image.png";
import Events from "./Events";
import blogs from "../../assets/WhatsNewSection/Blogs_Examples.png";
import videos from "../../assets/WhatsNewSection/Videos_Examples.png";
import podcast from "../../assets/WhatsNewSection/Videos_Examples.png";
import whatsNewIcon from "../../assets/TabIcons/Whats_New_Main.svg";
import download_section from "../../assets/WhatsNewSection/Download_Counter_Section_Image.png";
import { useSelector } from "react-redux";
import theme from "../../theme/theme";
import podcast_icon from "../../assets/WhatsNewSection/Podcast.svg";
import video_icon from "../../assets/WhatsNewSection/Videos.svg";
import blogs_icon from "../../assets/WhatsNewSection/Blogs.svg";
import AnimatedNumber from "../../components/Count/AnimatedCount";

const featureList = [
  {
    title: "Blogs",
    description:
      "Explore insightful stories, tech updates, and interactive content.",
    image: blogs,
    icon: blogs_icon,
  },
  {
    title: "Videos",
    description:
      "Watch engaging video content about the latest technologies and practices.",
    image: videos,
    icon: video_icon,
  },
  {
    title: "Podcast",
    description:
      "Listen to discussions covering various topics around the world.",
    image: podcast,
    icon: podcast_icon,
  },
];

const DownloadCount = ({ count }) => {
  return (
    <DownloadCountContainer>
      <ContentWrapper>
        <TextSection>
          <Typography
            variant="body1"
            textAlign="center"
            sx={{
              color: "#fff",
              textTransform: "uppercase",
            }}
          >
            LET'S #INFLATETHEEARTH TOGETHER
          </Typography>
          <Typography
            variant="h4"
            component="h2"
            sx={{ color: "#fff", fontFamily: "Houschka Rounded Alt" }}
          >
            Join the Circle4Life App
          </Typography>
        </TextSection>

        <StatsBox>
          <Typography
            variant="h2"
            sx={{
              color: "#fff",
              fontWeight: theme.typography.fontWeightBold,
              fontFamily: "Houschka Rounded Alt",
            }}
          >
            <AnimatedNumber target={count} />
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: "#fff", fontFamily: "Houschka Rounded Alt" }}
          >
            Circle4Life Members
            <br />
            Onboarded
          </Typography>
        </StatsBox>
      </ContentWrapper>
      <ImageSection>
        <PeopleImage src={download_section} alt="Diverse group of people" />
      </ImageSection>
    </DownloadCountContainer>
  );
};

const WhatsNew = () => {
  const { isShowAnnouncements, count } = useSelector((state) => state.announcement);
  return (
    <Container>
      {isShowAnnouncements && (
        <>
          <TopSection>
            <Box flex={1}>
              <MobilePreviewImage
                src={whats_new_banner}
                alt="Mobile App Preview"
              />
            </Box>
            <FeatureContent>
              <img src={whatsNewIcon} alt="what's new" />
              <Typography
                variant="subtitle1"
                sx={{
                  color: "#7a7a7a",
                  marginBottom: "8px",
                  fontWeight: 700,
                  textAlign: "center",
                }}
              >
                FEATURES IN VER 3.0
              </Typography>
              <Typography
                variant="h3"
                sx={{
                  marginBottom: "20px",
                  fontSize: "56px",
                  fontWeight: 600,
                  color: "#101117",
                  fontFamily: "Houschka Rounded Alt",
                  textAlign: "center",
                }}
              >
                What's New
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "#101117",
                  lineHeight: 1.6,
                  fontSize: "18px",
                  textAlign: "center",
                  width: "75%",
                }}
              >
                Discover exciting new features, including an updated UI for
                smoother navigation, news articles, interactive quizzes, and
                enhanced carbon footprint tracking. Stay informed and engaged
                with the latest updates, all in one place!
              </Typography>
            </FeatureContent>
          </TopSection>

          <FeaturesSection>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: "20%",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                variant="h3"
                className="section-title"
                sx={{
                  fontFamily: "Houschka Rounded Alt",
                  color: "#fff",
                }}
              >
                Join the Circle
              </Typography>
              <Typography
                variant="subtitle1"
                className="section-subtitle"
                width="40%"
                fontWeight="300"
              >
                Connect with other TCS-ers from around the globe and share your
                blogs, videos, podcast and more!
              </Typography>
            </Box>
            <div className="features-container">
              {featureList.map((feature, id) => (
                <FeatureCard
                  key={feature.title}
                  sx={{
                    flexDirection: id % 2 !== 0 ? "column" : "column-reverse",
                  }}
                >
                  <div className="card-media">
                    <img
                      src={feature.image}
                      alt={feature.title}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <CardContent className="card-content">
                    <Typography variant="h6" gutterBottom>
                      {feature.title} <img src={feature.icon} height="20px" />
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {feature.description}
                    </Typography>
                  </CardContent>
                </FeatureCard>
              ))}
            </div>
          </FeaturesSection>

          <StayUpdated>
            <Box flex={1}>
              <VolunteerImage src={stay_updated} alt="Join as a Volunteer" />
            </Box>
            <Box flex={1}>
              <Typography
                variant="h3"
                gutterBottom
                sx={{
                  fontWeight: 600,
                  fontFamily: "Houschka Rounded Alt",
                  color: "#fff",
                }}
              >
                Stay Updated
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "#fff",
                  lineHeight: 1.6,
                }}
              >
                Stay informed with real-time company updates, upcoming events,
                and important announcements. Get the latest news and connect
                with TCS-ers worldwide, all in one place!
              </Typography>
            </Box>
          </StayUpdated>
        </>
      )}
      <Events />
      {isShowAnnouncements && count !== 0 && <DownloadCount count={count} />}
    </Container>
  );
};

export default WhatsNew;

const Container = styled("div")({
  // maxWidth: "1200px",
  margin: "0 auto",
  // padding: "24px",
});

const TopSection = styled("div")({
  display: "flex",
  padding: "0 20px",
  gap: "40px",
  marginBottom: "48px",
  "@media (max-width: 768px)": {
    flexDirection: "column",
  },
});

const FeatureContent = styled("div")({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
});

const MobilePreviewImage = styled("img")({
  width: "100%",
  height: "auto",
  display: "block",
});

const FeaturesSection = styled("div")({
  backgroundColor: "#171717",
  padding: "20px",
  "& .features-container": {
    display: "flex",
    gap: "24px",
    "@media (max-width: 768px)": {
      flexDirection: "column",
    },
  },
  "& .section-title": {
    marginBottom: "32px",
    textAlign: "left",
  },
  "& .section-subtitle": {
    color: "#fff",
    marginBottom: "40px",
    fontSize: "15px",
    textAlign: "left",
  },
});

const FeatureCard = styled(Card)({
  // flex: 1,
  display: "flex",
  borderRadius: "16px",
  overflow: "hidden",
  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  "& .card-media": {
    height: "160px",
    backgroundColor: "#e3f2fd",
  },
  "& .card-content": {
    padding: "16px",
  },
});

const StayUpdated = styled("div")({
  display: "flex",
  gap: "40px",
  alignItems: "center",
  padding: "30px 0px",
  backgroundColor: "#171717",
  "@media (max-width: 768px)": {
    flexDirection: "column",
  },
});

const VolunteerImage = styled("img")({
  width: "100%",
  // maxWidth: "400px",
  height: "auto",
  display: "block",
});

const DownloadCountContainer = styled(Box)(() => ({
  width: "100%",
  backgroundColor: "#4e84c4",
  color: "#fff",
  borderRadius: "4px",
  display: "flex",
  alignItems: "flex-end",
  flexWrap: "wrap",
  justifyContent: "space-between",
  height: "150px",
  marginTop: '10px',

  "@media (max-width: 600px)": {
    height: "auto",
  },
}));

const ContentWrapper = styled(Box)({
  display: "flex",
  justifyContent: "space-around",
  alignItems: "center",
  padding: "10px",
  width: "70%",
  height: "100%",
  "@media (max-width: 600px)": {
    flexDirection: "column",
    alignItems: "center",
    gap: "24px",
    width: "100%",
  },
});

const TextSection = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
});

const StatsBox = styled(Box)({
  textAlign: "center",
});

const PeopleImage = styled("img")({
  width: "100%",
  height: "85%",
  borderRadius: "8px",
  "@media (max-width: 600px)": {
    display: "none",
  },
});

const ImageSection = styled("div")({
  display: "flex",
  alignItems: "flex-end",
  width: "25%",
  height: "100%",
});
